import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../../styles';

const styles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
  padding-bottom: 90px;
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
  .HomepagePhoto_image {
    width: 80px;
    height: 77px;
  }
  h3 {
    padding: 15px 0 25px;
    text-align: center;
    color: ${colors.brand2};
    text-align: center;
    color: ${colors.brand1};
    font-weight: 300;
    font-size: 40px;
    @media(min-width: 992px) {
      font-size: 48px;
    }
  }
  .PhotoList_heading {
    flex: 1;
    background-size: cover;
    background-position: center center;
    color: ${colors.brand1};
    font-size: 45px;
    font-weight: 500;
    position: relative;
    height: 200px;
    padding: 50px 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 5;
  }
  .PhotoList_list {
    width: 100%;
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    flex-flow: row wrap;
    justify-content: center;
    transition: all .3s ease-out;

    .PhotoList_item {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 23%;
      margin: 7px;
      overflow: hidden;
      transition: all .3s ease-out;
      &:hover {
        .PhotoList_image {
          transform: scale(1.1);
          transition: all .3s ease-out;
        }
      }

      a {
        position: relative;
        display: block;
      }
      .PhotoList_imageTitle {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        padding-top: 50%;
        width: 100%;
        z-index: 1;
        text-align: center;
        opacity: 0;
        transition: all .5s ease;
        font-weight: 700;
        font-size: 18px;
        color: ${colors.body};
        z-index: 2;
        &:hover {
          opacity: 1;
        }
        &:after {
          content:'';
          width: 26px;
          height: 26px;
          background-image: url('/images/icon-plus.svg');
          position: absolute;
          display: block;
          top: calc(50% - 26px);
          left: 50%;
          margin-left: -13px;
          z-index: -1;
        }
        &:before {
          content:'';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: ${colors.brand2};
          opacity: .85;
          position: absolute;
          display: block;
          z-index: -2;
        }
      }
      .PhotoList_image {
        position: relative;
        z-index: 0;
        width: 100%;
        padding-top: 90%;
        background-size: cover;
        background-position: center center;
        z-index: 1;
        transition: all .3s ease-out;
      }
    }
  }
  .PhotoList_photoLink {
    background-color: ${colors.brand1};
    overflow: hidden;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand1};
      transition: all .3s ease-out;

      a {
        transform: scale(1.1);
        transition: all .3s ease-out;
      }
    }

    img {
      width: 70px;
      margin-bottom: 10px;
      transition: all .3s ease-out;
    }

    a {
      color: ${colors.white};
      width: 100%;
      height: 100%;
      display: flex !important;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      line-height: 1.2;
      transition: all .3s ease-out;

      span {
        font-size: 24px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
  .PhotoList_videoLink {
    background-color: ${colors.brand2};
    transition: all .3s ease-out;
    padding: 20px 15px 15px 15px !important;
    color: ${colors.body};
    &:hover {
      background-color: ${colors.brand2};
      transition: all .3s ease-out;
      a {
        transform: scale(1.05);
        transition: all .3s ease-out;
      }
    }

    img {
      width: 70px;
      margin-bottom: 10px;
      transition: all .3s ease-out;
    }

    a {
      color: ${colors.body};
      width: 100%;
      height: 100%;
      display: flex !important;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      line-height: 1.2;
      transition: all .3s ease-out;

      span {
        font-size: 24px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
`;

function PhotoGalleryList({ page }) {
  return (
    <div className={styles}>
      <div className="container">
        <h3>Portfolio</h3>
        <ul className="PhotoList_list">
          {
            get(page, 'photo_gallery').slice(0, 7).map(item => (
              <li className="PhotoList_item" key={item._id} >
                <Link name="portfolio-filtered" params={{ gallery: item.photo_catergory }}>
                  <div style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'images[0].contentUrl') || get(item, 'images[1].contentUrl'), { width: 800, height: 800 })})` }} className="PhotoList_image" />
                  <span className="PhotoList_imageTitle">{item.photo_catergory}</span>
                </Link>
              </li>
            ))
          }
          <li className="PhotoList_item PhotoList_photoLink"><Link name="portfolio"><img src="/images/icon-photo.svg" alt="Icon Button" />Visit Our<span>Photo Gallery</span></Link></li>
          {/* <li className="PhotoList_item PhotoList_videoLink">
          <Link name="video-gallery"><img src="/images/icon-video-white.svg"
          alt="Icon Button" />Visit Our<span>Video Gallery</span></Link></li> */}
        </ul>
      </div>
    </div>
  );
}

PhotoGalleryList.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'galleries',
  },
)(PhotoGalleryList);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/PhotoGalleryList.js